if (!customElements.get('urgency-countdown')) {
  class UrgencyCountdown extends HTMLElement {
    constructor() {
      super();
      this.tick = this.tick.bind(this);
    }

    connectedCallback() {
      this.storageKey = this.dataset.storageKey || 'urgency-countdown';
      this.onExpire = this.dataset.onExpire === 'hide' ? 'hide' : 'restart';
      this.initialHours = parseInt(this.dataset.initialHours, 10) || 0;
      this.initialMinutes = parseInt(this.dataset.initialMinutes, 10) || 0;
      this.initialSeconds = parseInt(this.dataset.initialSeconds, 10) || 0;
      this.restartMinHours = parseInt(this.dataset.restartMinHours, 10);
      this.restartMaxHours = parseInt(this.dataset.restartMaxHours, 10);
      if (isNaN(this.restartMinHours)) this.restartMinHours = this.initialHours;
      if (isNaN(this.restartMaxHours)) this.restartMaxHours = this.initialHours;
      if (this.restartMaxHours < this.restartMinHours) {
        const tmp = this.restartMinHours;
        this.restartMinHours = this.restartMaxHours;
        this.restartMaxHours = tmp;
      }

      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      const stored = this.readStored();
      const now = Date.now();

      if (stored && stored.expiresAt > now) {
        this.expiresAt = stored.expiresAt;
      } else if (stored && stored.expiresAt <= now && this.onExpire === 'hide') {
        this.style.display = 'none';
        return;
      } else if (stored && stored.expiresAt <= now) {
        this.expiresAt = now + this.randomRestartMs();
        this.writeStored();
      } else {
        this.expiresAt = now + this.initialMs();
        this.writeStored();
      }

      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    initialMs() {
      return ((this.initialHours * 60 + this.initialMinutes) * 60 + this.initialSeconds) * 1000;
    }

    randomRestartMs() {
      const h = this.randInt(this.restartMinHours, this.restartMaxHours);
      const m = this.randInt(0, 59);
      const s = this.randInt(0, 59);
      return ((h * 60 + m) * 60 + s) * 1000;
    }

    randInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    readStored() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed.expiresAt !== 'number') return null;
        return parsed;
      } catch (e) {
        return null;
      }
    }

    writeStored() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({ expiresAt: this.expiresAt }));
      } catch (e) {
        // localStorage unavailable (private mode, quota) — keep going in-memory.
      }
    }

    pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    tick() {
      const remaining = this.expiresAt - Date.now();
      if (remaining <= 0) {
        if (this.onExpire === 'hide') {
          if (this.interval) clearInterval(this.interval);
          this.writeStored();
          this.style.display = 'none';
          return;
        }
        this.expiresAt = Date.now() + this.randomRestartMs();
        this.writeStored();
        this.tick();
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
    }
  }

  customElements.define('urgency-countdown', UrgencyCountdown);
}
